import { render } from "./ReservationArrowLeftIcon.vue?vue&type=template&id=638d2cab"
const script = {}

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__